import { get } from "@common/services/request";
import { apiEndpoints } from "@common/constants/urls";

export function getBreweryInformation() {
  return get(apiEndpoints.brewery);
}
